import { render, staticRenderFns } from "./index-full.vue?vue&type=template&id=864fb984&"
import script from "./index-full.vue?vue&type=script&setup=true&lang=ts&"
export * from "./index-full.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('864fb984')) {
      api.createRecord('864fb984', component.options)
    } else {
      api.reload('864fb984', component.options)
    }
    module.hot.accept("./index-full.vue?vue&type=template&id=864fb984&", function () {
      api.rerender('864fb984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/regions/index-full.vue"
export default component.exports